/** Quantidade de caracteres do ano em uma data ISO (`YYYY-MM-DD…`). */
const ISO_YEAR_LENGTH = 4;

/** Casa uma data ISO que começa com quatro dígitos seguidos de `-`. */
const ISO_DATE_PREFIX = /^\d{4}-/;

/**
 * Extrai o ano de uma data ISO **sem** conversão de fuso horário.
 *
 * A fatia literal é deliberada: `dayjs('2023-01-01T00:00:00Z').year()` devolve
 * `2022` em qualquer fuso negativo — e o Brasil inteiro é fuso negativo. Como
 * este ano é usado para **classificar** a parcela (em que ano ela entra na
 * consolidação), e não para exibir, o que vale é o que o backend disse.
 *
 * A formatação para exibição continua em `formatContractDate`, onde o
 * deslocamento é apenas visual.
 *
 * @param value - Data ISO vinda do backend.
 * @returns O ano como número, ou `null` quando a data não veio ou não é ISO.
 *
 * @example
 * ```ts
 * getParcelYear('2023-01-01T00:00:00Z'); // 2023
 * getParcelYear(null);                   // null
 * ```
 */
export function getParcelYear(value: string | null | undefined): number | null {
  if (!value || !ISO_DATE_PREFIX.test(value)) return null;
  return Number(value.slice(0, ISO_YEAR_LENGTH));
}
